import React from 'react';
import googleplay from '../../../assets/img/googleplay.png';
import appstore from '../../../assets/img/appstore.png';

const MobileAppSection = ({ themeData }: any) => {
  return (
    <>
      <section className="mobapp-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="mobapp-subtract-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mobapp-content">
                      <div className="section-title2">
                        <h2
                          style={{
                            color: `#${themeData?.theme_2?.home?.section_9?.h2color}`,
                          }}
                        >
                          {themeData?.theme_2?.home?.section_9?.title}
                        </h2>
                      </div>
                      <p
                        style={{
                          color: `#${themeData?.theme_2?.home?.section_9?.paracolor}`,
                        }}
                      >
                        {themeData?.theme_2?.home?.section_9?.paragraph}
                      </p>
                      <ul className="applinks">
                        <li>
                          <a
                            target="_blank"
                            href={themeData?.theme_2?.home?.section_9?.ios_link}
                          >
                            <img src={appstore} alt="" />
                          </a>
                        </li>

                        <li>
                          <a
                            target="_blank"
                            href={
                              themeData?.theme_2?.home?.section_9?.android_link
                            }
                          >
                            <img src={googleplay} alt="" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mobapp-img text-center">
                      <img src={`${themeData?.theme_2?.home?.section_9?.banner}`} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileAppSection;
